"use client";

import { displayValue } from "@/components/OtherBetsDropdown";
import { footballTrendClass } from "./FootballTrendUtils";

export default function FootballThreeColSection({ title, items, width = "ods-50" }) {
    return (
        <div
            className={`football-ods-detail-item ${width} flex min-w-0 flex-col !bg-transparent !p-0`}
        >
            <div className="relative flex w-full flex-row gap-[10px]">
                <div className="text-white relative z-[1] cursor-default select-none rounded-t-[4px] bg-[var(--theme-live-chip-bg)] px-2 py-1 text-[12px] font-bold leading-tight">
                    {title}
                </div>
            </div>
            <div className="bg-[var(--theme-tab-inactive)] -mt-px rounded-b-[4px] rounded-tr-[4px] p-2.5">
                <div className="football-odstb-odds-list">
                    {items.map((item, i) => (
                        <div key={i}>
                            <div className="football-title-odds">{item.label}</div>
                            <div className={`odds ods-100 ods-white max-md:!text-[9px] ${footballTrendClass(item.trend)}`}>
                                {displayValue(item.value)}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

